import { motion } from "framer-motion";
import { CheckCircle2 } from "lucide-react";
import { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";

export default function SuccessMessage() {
  const [showConfetti, setShowConfetti] = useState(false);
  const[message ,setMessage] = useState('');
  const navigate = useNavigate()
  const {state} = useLocation();


  useEffect(() => {
    const timer = setTimeout(() => setShowConfetti(true), 500);
    if (state?.fromPage === 'contactingService') {
      setMessage('Your Request Cancelled Successfully !!!');
    }
    return () => clearTimeout(timer);
  }, []);

  return (
    <div className="flex items-center justify-center h-screen w-full bg-white p-4 overflow-hidden relative">
      {/* Confetti circles */}
      {showConfetti &&
        Array.from({ length: 30 }).map((_, i) => (
          <motion.div
            key={i}
            className="absolute w-2 h-2 rounded-full"
            style={{
              backgroundColor: ["#34d399", "#60a5fa", "#facc15", "#f472b6", "#c084fc"][i % 5],
              top: "50%",
              left: "50%",
            }}
            initial={{ x: 0, y: 0, opacity: 1 }}
            animate={{
              x: (Math.random() - 0.5) * 400,
              y: (Math.random() - 0.5) * 400,
              opacity: 0,
            }}
            transition={{
              duration: 1.5,
              ease: "easeOut",
              delay: Math.random() * 0.3,
            }}
          />
        ))}

      <motion.div
        initial={{ scale: 0.8, opacity: 0 }}
        animate={{ scale: 1, opacity: 1 }}
        transition={{ type: "spring", stiffness: 300, damping: 20 }}
        className="flex flex-col items-center justify-center bg-green-100 rounded-2xl shadow-xl p-6 max-w-md w-full z-10"
      >
        {/* Pulsing ring behind icon */}
        <div className="relative flex items-center justify-center">
          <motion.div
            className="absolute h-24 w-24 rounded-full bg-green-400 opacity-20"
            animate={{
              scale: [1, 1.4],
              opacity: [0.4, 0],
            }}
            transition={{
              repeat: Infinity,
              duration: 1.5,
              ease: "easeOut",
            }}
          />
          <motion.div
            initial={{ rotate: -90, scale: 0 }}
            animate={{ rotate: 0, scale: 1 }}
            transition={{ type: "spring", stiffness: 400, damping: 15, delay: 0.2 }}
            className="text-green-600"
          >
            <CheckCircle2 className="h-20 w-20" />
          </motion.div>
        </div>

        <motion.h2
          initial={{ y: 20, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          transition={{ delay: 0.4, duration: 0.5 }}
          className="font-satoshi mt-6 text-center text-2xl md:text-3xl font-bold text-green-800"
        >
          Your Order Gets Cancelled 
        </motion.h2>

        <motion.p
          initial={{ y: 10, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          transition={{ delay: 0.6, duration: 0.4 }}
          onClick={()=>navigate('/customer-activity')}
          className="font-satoshi mt-4 text-sm md:text-base text-blue-700 text-center underline "
        >

          Get full details here
        </motion.p>
      </motion.div>
    </div>
  );
}
